import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=72f6813d&scoped=true"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=72f6813d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6813d",
  null
  
)

export default component.exports